<template>
  <div>
    <Card>
      <p slot="title"> Klaim Download </p>

      <Row type="flex" justify="space-between">
        <Col span="7">
          <Select
            v-model="bankAccountId"
            placeholder="Pilih Rekening Bank"
            clearable filterable
            @on-change="updateFilter">
              <Option v-for="bankAccount in bankAccounts" :value="bankAccount.id" :key="bankAccount.id">
                {{ bankAccount.accountName }}
              </Option>
          </Select>
        </Col>
        <Col span="5">
          <ButtonGroup class="custom-group-parent">
            <Button class="custom-group">Tgl. Mutasi</Button>
              <Date-picker
                v-model="claimDateFilter"
                style="width: 180px;"
                type="daterange"
                format="yyyy-MM-dd"
                @on-change="updateFilter">
              </Date-picker>
          </ButtonGroup>
        </Col>
        <Col span="1">
          <Button type="primary"
            :loading="isLoadingSearch"
            icon="ios-search-strong"
            :disabled="!isSearch"
            @click="getClaim">
              <span v-if="!isLoadingSearch">Cari</span>
              <span v-else>Wait...</span>
          </Button>
        </Col>
        <Col span="9">
          <Button type="primary"
            :loading="isLoadingDownload"
            icon="ios-download-outline"
            :disabled="invoiceClaimData.length === 0"
            @click="downloadClaim">
              <span v-if="!isLoadingDownload">Download</span>
              <span v-else>Wait...</span>
          </Button>
        </Col>
      </Row>

      <br/>

      <!-- list table -->
      <Spin v-if="isLoadingSearch" size="large" fix></Spin>
      <Card v-else>
        <Table border :columns="columnsDataClaim" :data="invoiceClaimData"> </Table>
      </Card>

      <!-- table-sheet hidden -->
      <div id="table-to-excel" ref="sheetsDataTableList" hidden></div>

    </Card>
  </div>
</template>

<script>
  import { HTTP } from '@/components/http-lib'
  import moment from 'moment'

  const numeral = require('numeral');

  export default {
    data: () => ({
      bankAccounts: [],
      bankAccountId: null,
      claimDateFilter: [],
      isSearch: false,
      isLoadingSearch : false,
      isLoadingDownload : false,
      columnsDataClaim: [
        {
            title: 'Marking',
            key: 'markingHeaderCode'
        },
        {
            title: 'Nomor Klaim',
            key: 'claim_number'
        },
        {
            title: 'Tanggal Klaim',
            key: 'claim_date'
        },
        {
            title: 'Tanggal Invoice',
            key: 'invoiceDate'
        },
        {
            title: 'Bank Account Name',
            key: 'accountName',
        },
        {
            title: 'No. Container',
            key: 'containerNumber'
        },
        {
            title: 'Keterangan',
            key: 'description'
        },
        {
            title: 'Total Nilai Klaim',
            key: 'total_claim'
        },
      ],
      invoiceClaimData : [],
    }),
    methods: {
      showDateFormatted: function (stringToFormat) {
        let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
        return moment(dateToFormat).format("DD MMM YYYY")
      },
      updateFilter: function() {
        this.mutationData = [];
        let fBankAccount = this.bankAccountId;
        let fClaimDateFilter = this.claimDateFilter;

        if((fClaimDateFilter[0] != '' && fClaimDateFilter[0] != null) || (fBankAccount != '' && fBankAccount != undefined)) {
          this.isSearch = true;
        }else {
          this.isSearch = false;
        }
      },
      getBankAccounts: function () {
        HTTP.get("bankAccount/findAll/active")
        .then(response => {
          this.bankAccounts = response.data;
        })
        .catch(e => {
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 5
          });
        });
      },
      getClaim: function () {
        let startDate = null;
        let endDate = null;

        if(this.claimDateFilter[0] != "" && this.claimDateFilter[0] != null) {
            startDate = moment(this.claimDateFilter[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
            endDate = moment(this.claimDateFilter[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
        }

        let parent = this;
        let payload = {
          bankAccountId : this.bankAccountId,
          startClaimDate: startDate,
          endClaimDate: endDate,
          isDeleted: false
        }

        this.invoiceClaimData = [];
        this.isLoadingSearch = true;
        HTTP.post('claim/search', payload)
        .then(response => {
            let invoiceClaim = []
            _.forEach(response.data, function (value, index) {
                let total_claim = value.total_claim != null ? "Rp. " + numeral(value.total_claim).format('0,0') : '';
                let invoiceDate = value.receivable.invoice != null ? parent.showDateFormatted(value.receivable.invoice.invoicedate) : ''

                var containerNumber = '-'
                var containerCode = ''
                var invoicefee = value.receivable.debitAmount

                if (value.receivable.invoice != null) {
                    invoiceDate = value.receivable.invoice != null ? parent.showDateFormatted(value.receivable.invoice.invoicedate) : ''
                    containerNumber = value.receivable.invoice.packaging_list.container_loading != null ? value.receivable.invoice.packaging_list.container_loading.containernumber : ''
                    containerCode = value.receivable.invoice.packaging_list.container_loading != null ? value.receivable.invoice.packaging_list.container_loading.containercode : ''
                    invoicefee = value.receivable != null ? value.receivable.invoice.invoicefee : ''
                } else {
                    invoiceDate = parent.showDateFormatted(value.receivable.transactionDate)
                    containerNumber = '-'
                    containerCode = ''
                    invoicefee = value.receivable.debitAmount
                }

                let invoiceDueId = value.invoice_due != null ? value.invoice_due.id : ''
                let receivableRemaining = value.invoice_due != null ? value.invoice_due.receivableRemaining : ''

                let accountName = value.bank_account != null ? value.bank_account.accountName : '-'

                let iClaim = {
                    claimId: value.id,
                    receivableId: value.receivableid,
                    markingHeaderId: value.markingheaderid,
                    markingHeaderCode: value.marking_header.markingheadercode,
                    invoiceDate: invoiceDate,
                    claim_date: value.claim_date != null ? parent.showDateFormatted(value.claim_date) : '',
                    claim_number: value.claim_number,
                    containerNumber: containerNumber,
                    containerCode: containerCode,
                    total_claim: total_claim,
                    description: value.receivable.description,
                    file: value.filename,
                    claim_detail: value.claim_detail,
                    isApprove: value.isApprove,
                    invoiceFee: invoicefee,
                    invoiceDueId: invoiceDueId,
                    receivableRemaining: receivableRemaining,
                    accountName: accountName
                }
                invoiceClaim.push(iClaim);

            });

            this.invoiceClaimData = invoiceClaim;
            this.isLoadingSearch = false;
        })
        .catch(e => {
            this.isLoadingSearch = false;

            this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
            });
        });
      },
      downloadClaim : function () {
        this.isLoadingDownload = true;
        let data = this.invoiceClaimData;
        let columns = this.columnsDataClaim;

        console.log({data});

        let tempData =
        `<table id="exportedTable" summary="Code page support in different versions of MS Windows." rules="groups" frame="hsides" border="1">
          <thead valign="top">
            <tr>
              <th colspan="7" rowspan="4" style="font-weight: bold; font-size: 20px; color: 'MediumSeaGreen';"> ${data[0].accountName} </th>
            </tr>
            <tr><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr>
            <tr><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr>
            <tr><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr>
            <tr>`;
              // set columns
              for (const col of columns) {
                if (col.key === 'accountName') { continue; }
                tempData += `<th style="font-weight: bold; font-size: 12px; color: 'white'; background-color: 'DodgerBlue';"> ${col.title} </th>`;
              }

            tempData += `</tr></thead><tbody>`;

            // set body
            data.forEach(el => {
              let totalClaimFormatted =  el.total_claim.replace(/\D+/g, '').replace(/(\d)(?=(\d{3})+$)/g, '$1.');

              tempData +=
                `<tr>
                  <td style="text-align: center;"> ${el.markingHeaderCode} </td>
                  <td style="text-align: center;"> ${el.claim_number} </td>
                  <td style="text-align: center;"> ${el.claim_date} </td>
                  <td style="text-align: center;"> ${el.invoiceDate} </td>
                  <td style="text-align: center;"> ${el.containerNumber} </td>
                  <td style="text-align: center;"> ${el.description} </td>
                  <td style="text-align: right;"> ${totalClaimFormatted} </td>
                </tr>`
            });

        `</tbody></table>`;

        this.$refs.sheetsDataTableList.innerHTML = tempData;

        // exec table to excel
        let tableToExcel = (function() {
          let template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>';
          let format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) };

          return function(table, name) {
              if (!table.nodeType) table = document.getElementById(table);
              let ctx = {worksheet: name || 'Worksheet', table: table.innerHTML};
              let html = format(template, ctx);
              let blob = new Blob([html], { type: 'application/vnd.ms-excel' });
              let url = URL.createObjectURL(blob);

              let a = document.createElement('a');
              a.href = url;
              a.download = "DATA CLAIM - " + moment(new Date()).format("DDMMYYhhmmss") + '.xls';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
          }
        })();
        tableToExcel('exportedTable', 'CLAIM');
        this.isLoadingDownload = false;
      },
    },
    mounted() {
      this.getBankAccounts()
    },
  }
</script>



// WEBPACK FOOTER //
// ClaimDownload.vue?0d6c73f5